<template>
    <div>
        <VueHtml2pdf :show-layout="false" :float-layout="true"
            :enable-download="$browserDetect && $browserDetect.isFirefox ? true : false" :preview-modal="false"
            :paginate-elements-by-height="1400"
            :filename="'Industry Market Profile - ' + (this.$route.path.includes('sample') ? 'sample' : this.$route.params.id)"
            :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="landscape"
            pdf-content-width="1150px" ref="html2Pdf" @beforeDownload="beforeDownload($event)"
            @hasDownloaded="afterDownload($event)" @hasGenerated="afterDownload($event)">
            <section slot="pdf-content">
                <div class="pdf_docs prfl-pdf" ref="document">
                    <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="banner page">
                            <div class="section_body">
                                <img src="/img/pdf_logo.png" alt="" class="company_logo">
                                <h1>Industry Market Profile</h1>

                                <h6>{{ headerInfo.headerData.industry }}[{{ parseFloat(headerInfo.headerData.bznaics)
                                }}]</h6>
                                <ul>
                                    <li>Sector: <span>{{ headerInfo.headerData.sector }}</span></li>
                                    <li>Market Area: <span>{{ headerInfo.headerData.area }}</span></li>
                                    <li v-if="headerInfo.sales_class">
                                        Sales Class:
                                        <span>{{ headerInfo.sales_class }}</span>
                                    </li>
                                    <li>
                                        Release Date:
                                        <span>{{ release_display }}</span>
                                    </li>
                                </ul>
                                <div class="bottom_area">
                                    <div class="left">
                                        <!--<h4>Company Name</h4>
                                        <div class="logo_wpr">
                                            <img src="/img/vivo_Energy.png" alt />
                                            <h3>Vivo Energy Ltd.</h3>
                                        </div>-->
                                    </div>
                                    <div v-if="headerInfo.developer_name" class="right">
                                        <h5>Developed By</h5>
                                        <h3>{{ headerInfo.developer_name }}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="banner_footer">
                                <span class="author"><!--Joyce Meyer--> </span>
                                <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                            </div>
                        </div>
                    </section>
                    <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="company_info bg-grey page">
                            <div class="section_body">
                                <ul class="blue-crcl">
                                    <li>
                                        <p>About the Data</p>
                                        <p>Data Sources and Limitations</p>
                                    </li>
                                    <li>
                                        <h5>Competitors</h5>
                                        <p>Industry Locations Map</p>
                                        <p>Industry Market Area Operations</p>
                                    </li>
                                    <li>
                                        <h5>Market Volume</h5>
                                        <p>Industry Market Volume</p>
                                        <p>Market Share</p>
                                    </li>
                                    <li>
                                        <h5>Annual Sales</h5>
                                        <p>Average Annual Sales</p>
                                    </li>
                                    <li>
                                        <h5>COVID-19 Impacts</h5>
                                        <p>Month-to-Month Employment/Sales</p>
                                        <p>% Change from Dec-2019</p>
                                    </li>
                                    <li>
                                        <h5>Penetration</h5>
                                        <p>Market Penetration</p>
                                    </li>
                                    <li>
                                        <h5>Employment</h5>
                                        <p>Industry Employment</p>
                                    </li>
                                    <li>
                                        <h5>Productivity</h5>
                                        <p>Sales Per Employee</p>
                                        <p>Average Annual Wage</p>
                                        <p>Rent Per Employee</p>
                                    </li>
                                    <li>
                                        <h5>Startups</h5>
                                        <p>Startup Performance</p>
                                    </li>
                                    <li>
                                        <h5>Cessation Rates</h5>
                                        <p>2020-2021 Cessation Rates (note to Kristaps: change headings to reflect this)</p>
                                    </li>
                                    <li>
                                        <h5>Concentration</h5>
                                        <p>Industry Branch Concentration</p>
                                    </li>
                                    <li>
                                        <h5>Demographics</h5>
                                        <p>Age</p>
                                        <p>Education</p>
                                        <p>Employment</p>
                                        <p>Housing</p>
                                        <p>Income</p>
                                        <p>Race/ Ethnicity</p>
                                        <p>Total Population</p>
                                    </li>
                                </ul>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="about_info page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>About the Data</h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <div class="negetive_margin">
                                    <div class="md-layout mt-4 mb-4">
                                        <div class="md-layout-item md-size-50">
                                            <div class="blue-box">
                                                <span>Bizminer</span> data is widely accepted for industry analytical
                                                work, benchmarking, valuations, forensics and
                                                litigation. Bizminer content is accepted in US Tax Court
                                                (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by
                                                state, provincial and national taxing agencies in the US
                                                and Canada.
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50 info-text">
                                            <p>Raw data analyzed for Bizminer reports is sourced from
                                                an array of the nation's government and private
                                                statistical sources. None of these raw data sources
                                                creates the final measures reflected in Bizminer
                                                industry profiles. In total, Bizminer accesses over a
                                                billion sourced data points from 15 million business
                                                operations for each of its twice annual updates covering
                                                a 3-5 year time series. Historical data and Bizminer
                                                algorithms are used to inform and test projections for
                                                non-reporting firms. Data elements are sourced specifically from the sources
                                                listed below:</p>

                                            <p>While 100% firm coverage is desirable for analysis
                                                purposes, the greatest value of Bizminer reports rests
                                                in discerning patterns of activity, which are reflected
                                                in the large samples used to develop our reports. The
                                                overall current coverage of the databases surpasses 13
                                                million active business operations at any point in time.
                                                As is the case with any databases this large, some
                                                errors are inevitable. Some firms are missed and
                                                specific information on others is lacking from the
                                                database. Not all information received is uniform or
                                                complete, resulting in the need to develop projection
                                                algorithms for specific industry segments and metrics in
                                                some report series. No representation is made as to the
                                                accuracy of the databases utilized or the results of
                                                subsequent analyses.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="list_box blue-tick">
                                    <ul>
                                        <li>IRS Statistics of Income</li>
                                        <li>IRS SOI Corporation Tax Book</li>
                                        <li>IRS Statistics of Income</li>
                                        <li>US Economic Census</li>
                                        <li>US Census Quarterly Financial Reports</li>
                                        <li>US Census County Business Patterns</li>
                                        <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                                        <li>Bureau of Labor Statistics Monthly Unemployment Reports</li>
                                        <li>Bureau of Labor Statistics Annual Wage Survey</li>
                                        <li>Bureau of Labor Statistics Industry Productivity Reports</li>
                                        <li>Bureau of Labor Statistics Price Indices</li>
                                        <li>National Agricultural Statistical Service</li>
                                        <li>US Census Quarterly Financial Reports</li>
                                        <li>US Census Retail Trade Report</li>
                                        <li>Data Axle</li>
                                        <li>Business Valuation Resources (BVR)</li>
                                        <li>Credit Reporting Agencies</li>
                                        <li>Business Directories</li>
                                        <li>American Community Survey</li>
                                    </ul>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="insight_sec competitor_sec page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>Map</h2>
                                </div>
                                <div class="table_sec mt-4">
                                    <div class="competitors_map-header tbl-title">
                                        <h4>Industry Locations</h4>
                                        <p class="m-0 pt-2">
                                            {{ release_display }} Industry Market Area
                                            Operations (up to 250 closest in market area)
                                        </p>
                                    </div>
                                    <div class="white-sec-box">
                                        <img v-if="mapImage" :src="mapImage" class="map-image" alt="Map" />
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="insight_sec competitor_sec page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>Competitors</h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <h3 class="">Table</h3>
                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Industry Market Area Operations</h4>
                                    </div>
                                    <table v-if="this.years">
                                        <tr>
                                            <th></th>
                                            <th v-for="item in this.years" :key="item">{{ item }}</th>

                                        </tr>
                                        <tr v-for="item in tableData" :key="item.name">
                                            <td>{{ item.name }}</td>
                                            <td v-for="item in item.dates" :key="item">{{ item }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="table_sec mt-4">
                                    <div v-if="this.years" class="tbl-title">
                                        <h4>{{ this.years[this.years.length - 1] }} Industry Market Area Operations</h4>
                                    </div>
                                    <div class="tbl-wht-box light_border">
                                        <LineChartMulti v-if="marketAreaData && marketAreaData.labels" height="250px"
                                            :categories="marketAreaData.labels" :chartdata="marketAreaData.data" />
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="industry-market page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>Industry Market Volume</h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <h6 class="section-subtitle">Volume</h6>
                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Industry Market Area Operations</h4>
                                    </div>
                                    <table v-if="this.years" class="light_border">
                                        <tr>
                                            <th></th>
                                            <th v-for="item in this.years" :key="item">{{ item }}</th>
                                        </tr>
                                        <tr v-for="items in tableDataMarketVolume" :key="items.name">
                                            <td>{{ items.name }}</td>
                                            <td v-for="key in Object.keys(items.dates)" :key="key">${{
                                                commasSeparator(items.dates[key])
                                            }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div v-if="cmnText && cmnText.market && cmnText.market.share != ''"
                                    class="md-layout blue-title">
                                    <div class="md-layout-item md-size-100 p-0">
                                        <div class="tbl-title">
                                            <h4>Competitive Market Narrative</h4>
                                        </div>
                                        <div class="tbl-wht-box p-4 light_border">
                                            <p>
                                                {{ cmnText.market.volume }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="industry-market page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h6 class="section-subtitle">Share</h6>
                                </div>
                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Industry Market Area Operations</h4>
                                    </div>
                                    <table v-if="this.years" class="light_border">
                                        <tr>
                                            <th></th>
                                            <th v-for="item in this.years" :key="item">{{ item }}</th>
                                        </tr>
                                        <tr v-for="items in tableDataMarketShare" :key="items.name">
                                            <td>{{ items.name }}</td>
                                            <td v-for="key in Object.keys(items.dates)" :key="key">{{ items.dates[key]
                                            }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="annual-sales competitor_sec page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>Average Annual Sales <span>($)</span></h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <div class="table_sec mt-4 pt-4">
                                    <div class="tbl-title">
                                        <h4>Average Annual Sales ($)</h4>
                                    </div>
                                    <table v-if="this.years" class="light_border">
                                        <tr>
                                            <th></th>
                                            <th v-for="item in this.years" :key="item">{{ item }}</th>
                                            <th>% Change:2021 to {{ this.years[this.years.length - 1] }}</th>
                                        </tr>
                                        <tr v-for="items in tableDataMarketAnnualSales" :key="items.name">
                                            <td>{{ items.name }}</td>
                                            <td v-for="key in Object.keys(items.dates)" :key="key">{{ key == 4
                                                ? items.dates[key] + '%' : items.dates[key]
                                            }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="md-layout mt-4 blue-title">
                                    <div class="md-layout-item md-size-100 p-0">
                                        <div class="tbl-title">
                                            <h4>Competitive Market Narrative</h4>
                                        </div>
                                        <div class="tbl-wht-box border_light">
                                            <p v-if="cmnText">
                                                {{ cmnText.annualSales.average }}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="covid && tableDataMarketCovidImpact" class="covid-impct competitor_sec page">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>COVID-19 Impact</h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <div v-if="tableDataMarketCovidImpact" class="table_sec pt-4">
                                    <div class="tbl-title">
                                        <h4>Month-to-Month Employment-Sales</h4>
                                    </div>
                                    <table class="light_border">
                                        <tr>
                                            <th></th>
                                            <th>Employment</th>
                                            <th>Monthly Industry Market Volume</th>
                                            <th>Average Monthly Site Sales</th>
                                        </tr>
                                        <tr v-for="items in tableDataMarketCovidImpact" :key="items.name">
                                            <td>{{ items.name }}</td>
                                            <td v-for="key in Object.keys(items.dates)" :key="key">${{ items.dates[key] }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="covid && tableDataMarketCovidImpact" class="covid-impct competitor_sec page">
                            <div class="section_body">
                                <div v-if="tableDataMarketCovidImpactChange" class="table_sec change-sec mt-4">
                                    <div class="tbl-title">
                                        <h4>% Change from Dec-19</h4>
                                    </div>
                                    <table class="light_border covid_table">
                                        <md-table v-model="tableDataMarketCovidImpactChange" table-header-color="blue"
                                            class="covid_table">
                                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                                <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                                <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                    :md-label="covidChangeColumns[key]">
                                                    {{ item.dates[key] }}
                                                </md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </table>
                                </div>
                                <div v-if="covidImpactChangeLineChart" class="table_sec change-sec mt-4">
                                    <div class="tbl-title">
                                        <h4>Monthly Change Index (Dec-19=1.00)</h4>
                                    </div>
                                    <div class="light_border">
                                        <LineChartMulti
                                            v-if="covidImpactChangeLineChart && covidImpactChangeLineChart.data && covidImpactChangeLineChart.data.labels"
                                            height="300px" :categories="covidImpactChangeLineChart.data.labels"
                                            :chartdata="covidImpactChangeLineChart.data.series" />
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>
                    <section ref="page11" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="penetration insight_sec competitor_sec page" v-if="penetrationData">
                            <div class="section_body">
                                <div class="section_title">
                                    <h2>Penetration</h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <div class="table_sec change-sec mt-4 pt-4">
                                    <div class="tbl-title">
                                        <h4>Market Penetration ($)</h4>
                                    </div>
                                    <table v-if="this.years">
                                        <tr>
                                            <th></th>
                                            <th v-for="item in this.years" :key="item">{{ item }}</th>
                                        </tr>
                                        <tr v-for="items in penetrationData.tableDataMarketPenetration" :key="items.name">
                                            <td>{{ items.name }}</td>
                                            <td v-for="key in Object.keys(items.dates)" :key="key">${{ items.dates[key]
                                            }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="negetive_margin pt-4">
                                    <div class="md-layout mt-4">
                                        <div class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4>Industry Market Volume($)</h4>
                                            </div>
                                            <div class="tbl-wht-box p-0">
                                                <BarChart v-if="penetrationData && penetrationData.labels" ycolor="#000000"
                                                    xcolor="#000000" :categories="penetrationData.labels"
                                                    :chartdata="penetrationData.data" :legend="true" />
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4>Competitive Market Narrative</h4>
                                            </div>
                                            <div class="tbl-wht-box">
                                                <p v-if="cmnText">
                                                    {{ cmnText.market.volume }}
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.
                                </p>
                            </div>
                        </div>
                    </section>
                    <section ref="page12" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="employment" class="annual-sales page">
                            <div class="section_body">
                                <div class="list-flx mb-4">
                                    <h2>Employment</h2>
                                    <h4>{{ moment(new Date()).format('MMM Do YYYY') }}</h4>
                                </div>
                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Industry Employment</h4>
                                    </div>
                                    <table v-if="employmentData && this.years" class="light_border">
                                        <tr>
                                            <th></th>
                                            <th v-for="item in this.years" :key="item">{{ item }}</th>
                                        </tr>
                                        <tr v-for="items in employmentData.tableDataMarketEmployment" :key="items.name">
                                            <td>{{ items.name }}</td>
                                            <td v-for="key in Object.keys(items.dates)" :key="key">{{ items.dates[key]
                                            }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="negetive_margin">
                                    <div class="md-layout mt-4">
                                        <div class="md-layout-item md-size-50">
                                            <div class="tbl-title">
                                                <h4>{{ this.years[this.years.length - 1] }} Average Industry Employment
                                                </h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <BarChart v-if="employmentChartData && employmentChartData.labels"
                                                    ycolor="#000000" xcolor="#000000"
                                                    :categories="employmentChartData.labels"
                                                    :chartdata="employmentChartData.data" :legend="true" />
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50">
                                            <div class="tbl-title">
                                                <h4>Employment</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <p class="p-4">How steady is industry employment? Does your firm employ
                                                    more or less than the average in this industry market? This
                                                    section reports on industry and small business employment.
                                                    If you input employment history for your firm, it is benchmarked
                                                    against the averages.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page13" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="Productivity_section page">
                            <div class="section_body">
                                <div class="list-flx">
                                    <h2>Productivity</h2>
                                </div>
                                <h6 class="section-subtitle">Values</h6>
                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Sales Per Employee ($)</h4>
                                    </div>
                                    <md-table v-model="tableDataSalesPerEmployee" table-header-color="blue"
                                        class="dark_blue light_border">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                            <md-table-cell class="md-table-side-label" md-label="Sales Per Employee ($)">{{
                                                item.name }}</md-table-cell>
                                            <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                :md-label="years[key]">{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                    <md-table v-model="tableDataAverageAnnualWage" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                            <md-table-cell class="md-table-side-label" md-label="Average Annual Wage ($)">{{
                                                item.name }}</md-table-cell>
                                            <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                :md-label="years[key]">{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                    <md-table v-model="tableDataRentPerEmployee" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                            <md-table-cell class="md-table-side-label" md-label="Rent Per Employee ($)">
                                                {{ item.name }}</md-table-cell>
                                            <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                :md-label="years[key]">{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>

                                <div class="tbl-title">
                                    <h4> Competitive Market Narrative</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p v-if="cmnText">
                                        {{ cmnText.salesEmpClasses }}
                                    </p>
                                </div>

                                <div class="tbl-title mt-4">
                                    <h4>Values</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p>
                                        Is your sales per employee efficiency measure above or below the US industry and
                                        market average?
                                        Sales per Employee levels are compared to your firm levels if you input both
                                        sales and employment
                                        for those years.<br><br>Average annual industry wages and rent per employee are
                                        displayed
                                        and benchmarked against your firm wage levels if they were input.
                                    </p>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page14" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="Productivity_section page">
                            <div class="section_body">
                                <h3>Chart</h3>


                                <div class="negetive_margin pt-4">
                                    <div class="md-layout mt-4">
                                        <div class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4>Sales per Employee ($)</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border p-0">
                                                <LineChartSimple
                                                    v-if="tableDataSalesPerEmployeeChart && tableDataSalesPerEmployeeChart.labels"
                                                    ycolor="#000000" xcolor="#000000"
                                                    :categories="tableDataSalesPerEmployeeChart.labels"
                                                    :chartdata="tableDataSalesPerEmployeeChart.data" :legend="true" />
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50 mb-4 px-4">
                                            <div class="tbl-title">
                                                <h4>Competitive Market Narrative</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <p v-if="cmnText">
                                                    {{ cmnText.employment }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="tbl-title mt-4">
                                    <h4>Chart</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p>
                                        How much more or less efficient is your operation relative to the competition?
                                        The Sales per Employee Index expresses your firm’s SPE as a percentage
                                        comparison
                                        to market and US levels where 100% reflects the same level. A zero per cent
                                        rating (+0%)
                                        indicates parity with the market benchmark.<br><br> The Efficiency Index divides
                                        sales per employee
                                        by average annual worker salary. Non‐wage factors may also affect efficiency but
                                        are not represented by this index.
                                    </p>
                                </div>

                            </div>


                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page15" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="startups_section page">
                            <div class="section_body">
                                <div class="list-flx mb-4">
                                    <h2>startups</h2>
                                </div>

                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Startup Performance (Firms)</h4>
                                    </div>
                                    <md-table v-model="tableDataStartupActivityRates" table-header-color="blue"
                                        class="dark_blue light_border">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                            <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                            <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                :md-label="years[key]">{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>

                                <div class="negetive_margin pt-4">
                                    <div class="md-layout mt-4">

                                        <div class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4>Industry Startups (2 Years)</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <BarChart
                                                    v-if="tableDataStartupPerformanceChart && tableDataStartupPerformanceChart.labels"
                                                    ycolor="#000000" xcolor="#000000" height="300px"
                                                    :categories="tableDataStartupPerformanceChart.labels"
                                                    :chartdata="tableDataStartupPerformanceChart.data" :legend="true" />
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4>Competitive Market Narrative</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <p v-if="cmnText">
                                                    {{ cmnText.startups }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page16" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="cessation_section page">
                            <div class="section_body">
                                <div class="list-flx">
                                    <h2>2018-2019 Cessation Rates</h2>
                                </div>

                                <div class="negetive_margin pt-4">
                                    <div class="md-layout">
                                        <div v-if="cessation" class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4>2018-2019 Cessation Rates</h4>
                                            </div>
                                            <md-table v-model="tableDataCessationRates" table-header-color="blue"
                                                class="dark_blue light_border">
                                                <md-table-row slot="md-table-row" slot-scope="{ item }">
                                                    <md-table-cell class="md-table-side-label">{{ item.name }}
                                                    </md-table-cell>
                                                    <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                        :md-label="years[key]">{{ item.dates[key] }}
                                                    </md-table-cell>
                                                </md-table-row>
                                            </md-table>
                                        </div>
                                        <div v-if="cessation && chartData" class="md-layout-item md-size-50 mb-4">
                                            <div class="tbl-title">
                                                <h4> {{ this.chartData.title }}</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <BarChart v-if="tableDataCessationChart && tableDataCessationChart.labels"
                                                    :categories="tableDataCessationChart.labels"
                                                    :chartdata="tableDataCessationChart.data" :legend="true"
                                                    height="240px" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tbl-title">
                                    <h4> Competitive Market Narrative</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p v-if="cmnText">
                                        {{ cmnText.cessation }}
                                    </p>
                                </div>
                                <div class="tbl-title mt-4">
                                    <h4>Cessation</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p>
                                        Cessation rates track the experience of business establishments, firms, small
                                        businesses, branches
                                        and startups doing business at the start of the time series, and still in
                                        operation today.<br>Firms
                                        which relocate but maintain independent operations are considered survivors if
                                        they do not move out
                                        of the jurisdiction being analyzed. Firms which become subsidiary locations, or
                                        whose location is
                                        terminated, are grouped with others which ceased operation. Any business entity
                                        which does not
                                        evidence ongoing operations (for example, by registering with government
                                        agencies, credit reporting
                                        services or business directories) is considered to have ceased viable operations
                                        and is classified
                                        in the "ceased operation" category.<br> Cessation rates occasionally reflect
                                        performance above
                                        100% or below 0% due to business migration among industries (changes in primary
                                        business line)
                                        or (in the case of location‐specific cessation rates) to business relocations.
                                        Migrants within a
                                        NAICS‐2 industry sector are considered as survivors in the in‐ migrant
                                        classification.
                                    </p>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page17" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div class="Ownership_section page">
                            <div class="section_body">
                                <div class="list-flx mb-4">
                                    <h2>Industry Branch Concentration</h2>
                                </div>


                                <div class="table_sec">
                                    <div class="tbl-title">
                                        <h4>Industry Branch Concentration (%)</h4>
                                    </div>
                                    <md-table v-model="tableDataBranchConcentration" table-header-color="blue"
                                        class="dark_blue light_border">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                            <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                            <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                                :md-label="years[key]">{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>

                                <div class="negetive_margin pt-4">
                                    <div class="md-layout ">

                                        <div class="md-layout-item md-size-50">
                                            <div class="tbl-title">
                                                <h4>Industry Branch Concentration (%)</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <LineChartSimple
                                                    v-if="tableDataBranchConcentrationChart && tableDataBranchConcentrationChart.labels"
                                                    :categories="tableDataBranchConcentrationChart.labels"
                                                    :chartdata="tableDataBranchConcentrationChart.data" :legend="true" />
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-50">

                                            <div class="tbl-title mt-4">
                                                <h4>Ownership</h4>
                                            </div>
                                            <div class="tbl-wht-box light_border">
                                                <p v-if="cmnText">
                                                    {{ cmnText.ownership }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                    </section>

                    <section ref="page18" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="demographics && !isRingAnalysis" class="Ownership_section page">
                            <div class="section_body">
                                <div class="list-flx">
                                    <h2>Market Area Demographics - 2020 American Community Survey </h2>
                                </div>

                                <div class="table_sec">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 pt-4 pb-4">
                                        <ul class="favorite-list companis-list-tabl competitors-list m-0"
                                            v-if="Object.values(demographics).length">
                                            <li class="favorite-list-item map-content p-0">

                                                <div class="tbl-title">
                                                    <h4>Age</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics.Age"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                            <li class="favorite-list-item map-content p-0 mt-4">

                                                <div class="tbl-title">
                                                    <h4>Education</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics.Education"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section ref="page19" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="demographics && !isRingAnalysis" class="Ownership_section page">
                            <div class="section_body">
                                <div class="table_sec">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 pt-4 pb-4">
                                        <ul class="favorite-list companis-list-tabl competitors-list m-0"
                                            v-if="Object.values(demographics).length">
                                            <li class="favorite-list-item map-content p-0">

                                                <div class="tbl-title">
                                                    <h4>Employment</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics.Employment"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section ref="page20" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="demographics && !isRingAnalysis" class="Ownership_section page">
                            <div class="section_body">
                                <div class="table_sec">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 pt-4 pb-4">
                                        <ul class="favorite-list companis-list-tabl competitors-list m-0"
                                            v-if="Object.values(demographics).length">
                                            <li class="favorite-list-item map-content p-0">

                                                <div class="tbl-title">
                                                    <h4>Housing</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics.Housing"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section ref="page21" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="demographics && !isRingAnalysis" class="Ownership_section page">
                            <div class="section_body">
                                <div class="table_sec">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 pt-4 pb-4">
                                        <ul class="favorite-list companis-list-tabl competitors-list m-0"
                                            v-if="Object.values(demographics).length">
                                            <li class="favorite-list-item map-content p-0 mt-4">

                                                <div class="tbl-title">
                                                    <h4>Income</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics.Income"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                            <li class="favorite-list-item map-content p-0 mt-4">

                                                <div class="tbl-title">
                                                    <h4>Race / Ethnicity</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics['Race / Ethnicity']"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section ref="page22" slot="pdf-content" class="pdf_docs prfl-pdf">
                        <div v-if="demographics && !isRingAnalysis" class="Ownership_section page">
                            <div class="section_body">
                                <div class="table_sec">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 pt-4 pb-4">
                                        <ul class="favorite-list companis-list-tabl competitors-list m-0"
                                            v-if="Object.values(demographics).length">
                                            <li class="favorite-list-item map-content p-0 mt-4">

                                                <div class="tbl-title">
                                                    <h4>Total Population</h4>
                                                </div>
                                                <!-- <div class="md-layout"> -->
                                                <div>
                                                    <md-table v-for="(table, index) in demographics['Total Population']"
                                                        :key="index + '_category'" table-header-color="blue"
                                                        class="collapse_table">
                                                        <md-table-row v-for="(item, name) in table"
                                                            :key="name + index + category + '_each'">
                                                            <md-table-cell class="md-table-side-label">{{ name }}
                                                            </md-table-cell>
                                                            <md-table-cell v-for="(key, i) in item" :key="key + i">{{
                                                                key
                                                            }}</md-table-cell>
                                                        </md-table-row>
                                                    </md-table>
                                                </div>
                                                <!-- </div> -->
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="tbl-title mt-4">
                                    <h4>Competitive Market Narrative</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p v-if="cmnText">
                                        {{ cmnText.demographics }}
                                    </p>
                                </div>

                                <div class="tbl-title mt-4">
                                    <h4>Demographics</h4>
                                </div>
                                <div class="tbl-wht-box light_border p-4">
                                    <p>Population demographics are applied from the Census Bureau's American Community
                                        Survey. Data for zip-county-metro-state and US markets are applied directly.
                                        Demographic totals for radius-based markets are applied at the level of
                                        aggregated zip codes which are co-joined to the selected market radius. Elements
                                        of this data are also integrated into our Sales per Person and Sales per
                                        Household calculations displayed on the Penetration>Table tab.​</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <template v-for="(tableData, demIndex) in demographicsChunk">
                        <section :key="'demographic-chunk-' + demIndex" :ref="'demographicsChunk' + demIndex"
                            slot="pdf-content" class="pdf_docs prfl-pdf">
                            <div class="Ownership_section page">
                                <div class="section_body">
                                    <div v-if="demIndex == 0" class="list-flx">
                                        <h2>Market Area Demographics- 2020 American Community Survey </h2>
                                    </div>

                                    <div class="md-layout-item md-medium-size-100 md-size-100 p-4">
                                        <ul class="favorite-list companis-list-tabl competitors-list"
                                            v-if="Object.values(tableData).length">
                                            <li v-for="(categoryData, category) in tableData" :key="category"
                                                class="favorite-list-item map-content px-4">
                                                <div class="tbl-title">
                                                    <h4>{{ category }}</h4>
                                                </div>
                                                <div>
                                                    <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                                        <md-table table-header-color="blue" class="collapse_table">
                                                            <md-table-row>
                                                                <md-table-cell class="md-table-side-label">
                                                                </md-table-cell>
                                                                <md-table-cell
                                                                    v-if="demog_3ring[Object.keys(demog_3ring)[0]]"
                                                                    colspan="2"
                                                                    class="md-table-side-label font-titles-demog">
                                                                    <h4>MARKET AREA</h4>
                                                                </md-table-cell>
                                                                <md-table-cell
                                                                    v-if="Object.keys(demog_3ring)[2] && demog_3ring[Object.keys(demog_3ring)[2]]"
                                                                    colspan="6"
                                                                    class="md-table-side-label font-titles-demog-last-el">
                                                                    <h4>3-RINGS</h4>
                                                                </md-table-cell>
                                                            </md-table-row>
                                                            <md-table-row>
                                                                <md-table-cell class="md-table-side-label">
                                                                </md-table-cell>
                                                                <md-table-cell class="md-table-side-label">
                                                                </md-table-cell>
                                                                <md-table-cell class="md-table-side-label">
                                                                </md-table-cell>
                                                                <md-table-cell
                                                                    v-if="demog_3ring[Object.keys(demog_3ring)[0]]"
                                                                    colspan="2"
                                                                    class="md-table-side-label font-titles-demog">
                                                                    Primary Radius
                                                                    <br />
                                                                    ({{ Object.keys(demog_3ring)[0] }} Miles)
                                                                </md-table-cell>
                                                                <md-table-cell
                                                                    v-if="demog_3ring[Object.keys(demog_3ring)[1]]"
                                                                    colspan="2"
                                                                    class="md-table-side-label font-titles-demog">
                                                                    Second Radius
                                                                    <br />
                                                                    ({{ Object.keys(demog_3ring)[1] }} Miles)
                                                                </md-table-cell>
                                                                <md-table-cell
                                                                    v-if="Object.keys(demog_3ring)[2] && demog_3ring[Object.keys(demog_3ring)[2]]"
                                                                    colspan="2"
                                                                    class="md-table-side-label font-titles-demog">
                                                                    Third Radius
                                                                    <br />
                                                                    ({{ Object.keys(demog_3ring)[2] }} Miles)
                                                                </md-table-cell>
                                                                <md-table-cell hidden="true" colspan="2"
                                                                    class="md-table-side-label font-titles-demog-last-el">

                                                                    <br />
                                                                </md-table-cell>
                                                            </md-table-row>
                                                            <template v-for="tableDataAux in tableData">
                                                                <template v-for="(data, i) in tableDataAux">
                                                                    <md-table-row v-for="(column, index) in data"
                                                                        :key="i + '_each_' + index + category">
                                                                        <md-table-cell
                                                                            class="md-table-side-label char-limit"
                                                                            :key="i + category + '_each_' + i + index">{{
                                                                                index
                                                                            }}
                                                                        </md-table-cell>

                                                                        <md-table-cell class="font-data-demog char-limit"
                                                                            :key="i + '_each_' + category + i + index">
                                                                            <div v-if="newMarketAreaData">
                                                                                {{
                                                                                    newMarketAreaData[checkTitle(index)][0].value[0]
                                                                                }}
                                                                            </div>
                                                                        </md-table-cell>
                                                                        <md-table-cell class="font-data-demog char-limit"
                                                                            :key="i + '_each_' + i + category + index">
                                                                            <div v-if="newMarketAreaData">
                                                                                {{
                                                                                    newMarketAreaData[checkTitle(index)][0].value[1]
                                                                                }}
                                                                            </div>
                                                                        </md-table-cell>

                                                                        <md-table-cell v-if="newDemog3Ring[0]"
                                                                            class="font-data-demog"
                                                                            :key="0 + i + category + i + index">{{
                                                                                newDemog3Ring[0][checkTitle(index)]
                                                                            }}</md-table-cell>
                                                                        <md-table-cell v-if="newDemog3Ring[0]"
                                                                            class="font-data-demog"
                                                                            :key="0 + i + category + 'percent' + i + index">{{
                                                                                newDemog3Ring[0][checkTitle(index) + ' Percent']
                                                                            }}
                                                                        </md-table-cell>

                                                                        <md-table-cell v-if="newDemog3Ring[1]"
                                                                            class="font-data-demog"
                                                                            :key="1 + i + category + i + index">{{
                                                                                newDemog3Ring[1][checkTitle(index)]
                                                                            }}</md-table-cell>
                                                                        <md-table-cell v-if="newDemog3Ring[1]"
                                                                            class="font-data-demog"
                                                                            :key="1 + i + category + 'percent' + i + index">{{
                                                                                newDemog3Ring[1][checkTitle(index) + ' Percent']
                                                                            }}
                                                                        </md-table-cell>

                                                                        <md-table-cell v-if="newDemog3Ring[2]"
                                                                            class="font-data-demog"
                                                                            :key="2 + i + category + i + index">{{
                                                                                newDemog3Ring[2][checkTitle(index)]
                                                                            }}</md-table-cell>
                                                                        <md-table-cell v-if="newDemog3Ring[2]"
                                                                            class="font-data-demog"
                                                                            :key="2 + i + category + 'percent' + i + index">{{
                                                                                newDemog3Ring[2][checkTitle(index) + ' Percent']
                                                                            }}
                                                                        </md-table-cell>
                                                                    </md-table-row>
                                                                </template>
                                                            </template>

                                                        </md-table>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="demIndex == (demographicsChunk.length - 1)">
                                        <div class="tbl-title mt-4">
                                            <h4>Competitive Market Narrative</h4>
                                        </div>
                                        <div class="tbl-wht-box light_border p-4">
                                            <p v-if="cmnText">
                                                {{ cmnText.demographics }}
                                            </p>
                                        </div>

                                        <div class="tbl-title mt-4">
                                            <h4>Demographics</h4>
                                        </div>
                                        <div class="tbl-wht-box light_border p-4">
                                            <p>Population demographics are applied from the Census Bureau's American
                                                Community
                                                Survey. Data for zip-county-metro-state and US markets are applied
                                                directly.
                                                Demographic totals for radius-based markets are applied at the level of
                                                aggregated zip codes which are co-joined to the selected market radius.
                                                Elements
                                                of this data are also integrated into our Sales per Person and Sales per
                                                Household calculations displayed on the Penetration>Table tab.​</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </template>


                </div>
            </section>
        </VueHtml2pdf>
    </div>
</template>
<script>
// import { ChartCard } from '@/components';
import LineChartSimple from '@/components/LineChartSimple.vue';
import LineChartMulti from '@/components/LineChartMulti.vue';
import BarChart from '@/components/BarChart.vue';
import VueHtml2pdf from 'vue-html2pdf';
import { mapState } from 'vuex';
import moment from 'moment'

Object.defineProperty(Array.prototype, 'chunk', {
    value: function (chunkSize) {
        var R = [];
        for (var i = 0; i < this.length; i += chunkSize)
            R.push(this.slice(i, i + chunkSize));
        return R;
    }
});

export default {
    components: {
        VueHtml2pdf,
        // ChartCard,
        LineChartSimple,
        LineChartMulti,
        BarChart
    },
    props: ['headerInfo', 'category', 'imrFile2'], //, 'imrFile2', 'compet', 'market', 'annual', 'covid', 'penetration', 'employment', 'salesEmp','years','Productivity','startups','cessation','ownership'],
    data() {
        return {
            isRingAnalysis: false,
            demographicsChunk: [],
            tableData: [],
            colouredLineChart: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 10,
                    }),
                    axisY: {
                        showGrid: true,
                        offset: 40,
                    },
                    axisX: {
                        showGrid: false,
                    },
                    low: 0,
                    showPoint: true,

                    height: '220px',
                },
            },
            moment: moment,
            tableDataMarketVolume: [],
            tableDataMarketShare: [],
            tableDataMarketAnnualSales: [],
            tableDataMarketCovidImpact: [],
            tableDataMarketCovidImpactChange: [],
            covidImpactChangeLineChart: [],
            tableDataMarketPenetration: [],
            colouredLineChart2: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 10,
                    }),
                    axisY: {
                        showGrid: true,
                        offset: 40,
                    },
                    axisX: {
                        showGrid: false,
                    },
                    showPoint: true,
                    height: '185px',
                },
            },
            showDialog: false,
            demographicsData: [],
            tableDataMarketEmployment: [],
            colouredLineChart3: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 10,
                    }),
                    axisY: {
                        showGrid: true,
                        offset: 40,
                    },
                    axisX: {
                        showGrid: false,
                    },
                    showPoint: true,
                    height: '200px',
                },
            },
            tableDataMarketEmpVolume: [],
            tableDataPercentMarketVolumeClass: [],
            tableDataAverageSalesClass: [],
            filtered_population: [],
            filtered_market_volume: [],
            filtered_market_share: [],
            filtered_annual_sales: [],
            filtered_penetration: [],
            filtered_employment: [],
            filtered_market_by_class: [],
            filtered_market_percent_by_class: [],
            filtered_average_sale_by_class: [],
            filtered_establishment_by_class: [],
            filtered_total_employment_by_class: [],
            filtered_average_employment_by_class: [],
            filtered_annual_sales_per_employee: [],
            filtered_average_annual_wage: [],
            filtered_rent_per_employee: [],
            filtered_startup_info: [],
            filtered_cessation_info: [],
            filtered_ownership_info: [],
            filtered_demographic_info: [],
            filtered_covid_info: [],
            filtered_covid_change_info: [],
            tableDataEstablishments: [],
            tableDataTotalEmployment: [],
            tableDataAverageEmployment: [],

            tableDataSalesPerEmployee: [],
            tableDataSalesPerEmployeeChart: [],
            tableDataAverageAnnualWage: [],
            tableDataRentPerEmployee: [],
            tableDataProductivityIndices: [],
            colouredLineProductivityChart: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 10,
                    }),
                    axisY: {
                        showGrid: true,
                        offset: 40,
                    },
                    axisX: {
                        showGrid: false,
                    },
                    showPoint: true,
                    height: "300px",
                },
            },


            tableDataStartupPerformance: [],
            tableDataStartupPerformanceChart: [],
            tableDataStartupActivityRates: [],
            startupActivityRatesLineChart: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 10,
                    }),
                    axisY: {
                        showGrid: true,
                        offset: 40,
                    },
                    axisX: {
                        showGrid: false,
                    },
                    showPoint: true,
                    height: "300px",
                },
            },

            tableDataCessationRates: [],
            tableDataCessationChart: [],
            pieChart: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    showLabel: false,
                    height: '150px',
                    legendNames: [],
                    labelInterpolationFnc: (value) => value,
                },
            },

            tableDataBranchConcentration: [],
            tableDataBranchConcentrationChart: [],
            colouredLineChart7: {
                data: {
                    labels: [],
                    series: [],
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 10,
                    }),
                    axisY: {
                        showGrid: true,
                        offset: 40,
                    },
                    axisX: {
                        showGrid: false,
                    },
                    showPoint: true,
                    height: '300px',
                },
            },
            locationsChunks: [],
            // employment: null,
            penetrationData: null,
            employmentData: null,
            employmentChartData: null,
            marketAreaData: null,
            tableDemog3Ring: null,
            newMarketAreaData: null,
            newDemog3Ring: {},
        }
    },
    mounted() {

        this.checkAlreadyAdded3RingAnalysis();
        this.init();
    },
    watch: {
        headerInfo() {
        },
        profile(newVal, oldVal) {
            this.init();
        }
    },
    computed: {
        ...mapState({
            profile: (state) => {
                return state.user.industryProfile;
            },
            mapImage: (state) => state.user.industryProfile.mapImage,
            pdfLoading: (state) => state.user.pdfLoading,
            user: (state) => state.user.user,
            locations: (state) => state.user.industryProfile['mapDataVestimate'] ?
                state.user.industryProfile['mapDataVestimate'].filter(x => x.lat !== null && x.lng !== null)
                : null,
            tableCompetitors: (state) =>
                state.user.industryProfile && state.user.industryProfile.data ? state?.user?.industryProfile?.data['competitors'] : '',
            marketVolume: (state) => state.user.industryProfile && state.user.industryProfile.data ? state.user.industryProfile.data['marketVolume'] : '',
            marketShare: (state) => state.user.industryProfile && state.user.industryProfile.data ? state.user.industryProfile.data['marketShare'] : '',
            years: (state) => state.user.industryProfile.years,
            release_years: (state) =>
                state.user.industryProfile.general.release_years,
            release_display: (state) => {
                return state?.user?.industryProfile?.general ? state?.user?.industryProfile?.general['release_display'] : '';
            },
            bznaics_code: (state) => state.user?.industryProfile?.general?.bznaics,
            sector_name: (state) => state.user.industryProfile.general.sector,
            industry_title: (state) => state.user.industryProfile.general.industry,
            update_month: (state) => state.user.industryProfile.updateMonth,
            display_area: (state) =>
                state.user.industryProfile.general.area_display_name,
            annualSales: (state) => state.user.industryProfile && state.user.industryProfile.data ? state.user.industryProfile.data['annualSales'] : '',
            annualSalesCols: (state) => state.user.industryProfile['annualSalesCols'],
            penetration: (state) => state.user.industryProfile.data ? state.user.industryProfile.data['penetration'] : '',
            employment: (state) => state.user.industryProfile.data ? state.user.industryProfile.data['employment'] : '',
            salesEmpSales: (state) =>
                state.user.industryProfile.data ? state.user.industryProfile.data['salesEmpSales'] : '',
            salesEmpCols: (state) => state.user.industryProfile['salesEmpCols'],
            salesEmpEmployment: (state) =>
                state?.user?.industryProfile?.data ? state?.user?.industryProfile?.data['salesEmpEmployment'] : null,
            productivityValues: state => state?.user?.industryProfile?.data ? state?.user?.industryProfile?.data['productivityValues'] : null,
            productivity: (state) =>
                state.user.industryProfile.data['productivityValues'],
            startupPerformance: (state) =>
                state?.user?.industryProfile?.data['startupsValues'],
            startupRates: (state) => state.user.industryProfile.data['startupsIndex'],
            cessation: (state) => state?.user?.industryProfile?.data ? state.user.industryProfile.data['cessation'] : null,
            ownership: (state) => state?.user?.industryProfile?.data ? state?.user?.industryProfile?.data['ownership'] : null,
            demographics: (state) => {
                return state?.user?.industryProfile?.data ? state?.user?.industryProfile?.data['demographics'] : null;
            },
            demog_3ring: (state) => {
                return state?.user?.industryProfile?.data ? state?.user?.industryProfile['demog_3ring'] : null;
            },
            covid: (state) => state.user.industryProfile.data ? state.user.industryProfile.data['covid'] : '',
            covidColumns: (state) => state?.user?.industryProfile?.data ? state?.user?.industryProfile?.data['covidColumns'] : [],
            covidChange: (state) => state.user.industryProfile.data ? state.user.industryProfile.data['covidChange'] : '',
            covidChangeColumns: (state) =>
                state.user.industryProfile.data ? state.user.industryProfile.data['covidChangeColumns'].filter(element => { return element !== ''; }) : [],

            startupsValues: state => state?.user?.industryProfile?.data ? state?.user?.industryProfile?.data['startupsValues'] : null,
            startupsIndex: state => state.user.industryProfile.data['startupsIndex'],
            chartData: (state) =>
                state.user.industryProfile.charts ? state.user.industryProfile.charts.test['Cessation'][0] : null,
            locations: (state) => state.user.industryProfile['mapDataVestimate'] ? state.user.industryProfile['mapDataVestimate'].filter(x => x.lat !== null && x.lng !== null) : null,
            cmnText: (state) => state.user.cmnText,
        }),
        pdfDownloadSetting() {
            return this.user && this.user.preferences && this.user.preferences.defaultPDFDownload ? this.user.preferences.defaultPDFDownload : '_blank'
        },
    },
    methods: {
        commasSeparator(n) {
            var parts = n.toString().split(".");
            const numberPart = parts[0];
            const decimalPart = parts[1];
            const thousands = /\B(?=(\d{3})+(?!\d))/g;
            return numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");
        },
        checkAlreadyAdded3RingAnalysis() {
            if (this.demog_3ring && Object.entries(this.demog_3ring).length !== 0) {
                this.isRingAnalysis = true;
                this.makeDemogTable();
                this.makeAreaTable();
            }
            else
                this.isRingAnalysis = false;
        },
        makeDemogTable() {
            let auxObject = null;

            if (this.demog_3ring[Object.keys(this.demog_3ring)[0]])
                auxObject = this.demog_3ring[Object.keys(this.demog_3ring)[0]];

            else if (this.demog_3ring[Object.keys(this.demog_3ring)[1]])
                auxObject = this.demog_3ring[Object.keys(this.demog_3ring)[1]];

            else if (this.demog_3ring[Object.keys(this.demog_3ring)[2]])
                auxObject = this.demog_3ring[Object.keys(this.demog_3ring)[2]];


            let dataFirstElement = auxObject.data;

            let auxArray = [];

            Object.keys(dataFirstElement).forEach(function (key) {
                if (!key.includes('Percent')) {


                    const [title, ...columnArray] = key.split(/(?=[A-Z0-9])/)
                    const column = columnArray.join("");

                    let auxObject = {
                        'title': title.toUpperCase(),
                        'value': key,
                        'label': this.checkTitle(this.formatLabelToDemoTable(column).trim()),
                    }

                    auxArray.push(auxObject);
                }
            }.bind(this))

            let groupedData = auxArray.reduce(function (r, a) {
                r[a.title] = r[a.title] || [];
                r[a.title].push(a);
                return r;
            }, Object.create(null));
            this.tableDemog3Ring = groupedData;

            this.addMarketFields();

            Object.values(this.demog_3ring).forEach(function (el, ind) {
                let auxArray = [];

                Object.entries(el.data).forEach(([key, value], index) => {

                    const [title, ...columnArray] = key.split(/(?=[A-Z0-9])/)
                    var column = columnArray.join("");
                    if (key == 'meanHHIncome' || key == 'occupiedHousingUnits' || key == 'occupiedHousingUnitsPercent')
                        column = key;

                    auxArray[this.checkTitle(this.formatLabelToDemoTable(column).trim())] = value;
                })
                this.newDemog3Ring[ind] = auxArray;
            }.bind(this))

        },
        addMarketFields() {
            let plus85 = {
                'title': 'AGE',
                'value': '85plusYears',
                'label': '85plus Years',
            }
            this.tableDemog3Ring.AGE.push(plus85);
        },
        formatLabelToDemoTable(string) {

            let auxStringReplace = string.replace('_', '-');

            let auxStringUpperCase = this.UpperCaseFirstLetter(auxStringReplace);

            const auxStringJoined = auxStringUpperCase.split(/(?=[A-Z])/).join(" ");
            let auxString = auxStringJoined;
            if (isNaN(auxStringJoined.charAt(0))) {
                const [firstElement, ...secondElement] = auxStringJoined.split(/(?=[0-9])/)
                auxString = firstElement + " " + secondElement.join("");
            }
            let label = auxString;
            return label;
        },
        UpperCaseFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.substr(1);
        },
        makeAreaTable() {
            let marketAreaArray = [];

            Object.entries(this.demographics).forEach(entry => {
                const [key, value] = entry;
                Object.entries(value).forEach(entryAux => {
                    Object.entries(entryAux[1]).forEach(elem => {
                        let auxObject = {
                            'title': this.checkTitle(elem[0]),
                            'value': elem[1],
                        }
                        marketAreaArray.push(auxObject);
                    })
                })
            });

            let groupedData = marketAreaArray.reduce(function (r, a) {
                r[a.title] = r[a.title] || [];
                r[a.title].push(a);
                return r;
            }, Object.create(null));

            this.newMarketAreaData = groupedData;


        },
        checkTitle(title) {
            switch (title) {
                case '2-plus Races':
                    return '2 Plus Races';
                case '85-plus Years':
                    return '85plus Years';

                case '$10k-14.9k Income':
                    //case '10k14-9k':
                    return '10k14-9k';

                case '$15k-24.9k Income':
                    //case '15k24-9k':
                    return '15k24-9k';

                case '$25k-34.9k Income':
                    //case '25k34-9k':
                    return '25k34-9k';

                case '$35k-49.9k Income':
                    //case '35k49-9k':
                    return '35k49-9k';

                case '$50k-74.9k Income':
                    //case '50k74-9k':
                    return '50k74-9k';

                case '$75k-99.9k Income':
                    //case '75k99-9k':
                    return '75k99-9k';

                case '$100k-149.9k Income':
                    //case '100k149-9k':
                    return '100k149-9k';

                case '$150k-199.9k Income':
                    //case '150k199-9k':
                    return '150k199-9k';

                case '150k199-9k':
                    return '150k199-9k';

                case 'Below $10k Income':
                    return 'Below 10k';

                case '>$200k Income':
                    return 'Over 200k';

                case 'School Graduateor Higher':
                    //case 'School Graduateor Higher':
                    return '% High School Graduate or Higher (total)';

                case 'School Graduateor Higher Percent':
                    return '% High School Graduate or Higher (total) Percent';

                case "Degreeor Higher":
                    //case "Degreeor Higher":
                    return "% Bachelor's Degree or Higher (total)";

                case "Degreeor Higher Percent":
                    //case "Degreeor Higher":
                    return "% Bachelor's Degree or Higher (total) Percent";


                case "Hispanic (all races)":
                    return 'Hispanic';

                /*case "Commute 15-29 Minutes":
                //case "15to29":
                  return '15-29';
                case "Commute 30-44 Minutes":
                //case "30to44":
                  return '30-44';
                case "Commute 45-89 Minutes":
                //case "45to89":
                  return '45-89';
                    */
                case "Commute < 15 Minutes":
                    return 'Less Than 14';

                case "Commute > 90 Minutes":
                    return '90 Plus';

                case "Rent Paid 15%-19.9% of Income (Households)":
                case "Paid 15-19_9of Income":
                    return 'Paid 15%-19.9% of Income';

                case "Rent Paid 15%-19.9% of Income (Households) Percent":
                case "Paid 15-19_9of Income Percent":
                    return 'Paid 15%-19.9% of Income Percent';

                case "Rent Paid 20%-24.9% of Income (Households)":
                case "Paid 20-24_9of Income":
                    return 'Paid 20%-24.9% of Income';

                case "Rent Paid 20%-24.9% of Income (Households) Percent":
                case "Paid 20-24_9of Income Percent":
                    return 'Paid 20%-24.9% of Income Percent';

                case "Rent Paid 25%-29.9% of Income (Households)":
                case "Paid 25-29_9of Income":
                    return 'Paid 25%-29.9% of Income';

                case "Rent Paid 25%-29.9% of Income (Households) Percent":
                case "Paid 25-29_9of Income Percent":
                    return 'Paid 25%-29.9% of Income Percent';

                case "Rent Paid 30%-34.9% of Income (Households)":
                case "Paid 30-34_9of Income":
                    return 'Paid 30%-34.9% of Income';

                case "Rent Paid 30%-34.9% of Income (Households) Percent":
                case "Paid 30-34_9of Income Percent":
                    return 'Paid 30%-34.9% of Income Percent';

                case "Rent Paid 35%-plus of Income (Households)":
                case "Paid 35 Plusof Income":
                    return 'Paid 35 Plus of Income';

                case "Rent Paid 35%-plus of Income (Households) Percent":
                case "Paid 35 Plusof Income Percent":
                    return 'Paid 35 Plus of Income Percent';

                case "Rent Paid < 15% of Income (Households)":
                case "Paid Less Than 15of Income":
                    return 'Paid Less Than 15% of Income';

                case "Rent Paid < 15% of Income (Households) Percent":
                case "Paid Less Than 15of Income Percent":
                    return 'Paid Less Than 15% of Income Percent';

                case "Owner Occupied Units: Value $50k-$99.9k":
                case "Occupied Units Value 50k99-9k":
                    return 'Occupied Units Value 50k-99.9k';

                case "Owner Occupied Units: Value $100k-$149.9k":
                case "Occupied Units Value 100k-149_9k":
                    return 'Occupied Units Value 100k-149.9k';

                case "Owner Occupied Units: Value $150k-$199.9k":
                case "Occupied Units Value 150k-199_9k":
                    return 'Occupied Units Value 150k-199.9k';

                case "Owner Occupied Units: Value $200k-$299.9k":
                case "Occupied Units Value 200k-299_9k":
                    return 'Occupied Units Value 200k-299.9k';

                case "Owner Occupied Units: Value $300k-$499.9k":
                case "Occupied Units Value 300k-499_9k":
                    return 'Occupied Units Value 300k-499.9k';

                case "Owner Occupied Units: Value $500k-$999.9k":
                case "Occupied Units Value 500k-999_9k":
                    return 'Occupied Units Value 500k-999.9k';

                case "Owner Occupied Units: Value < $50k":
                    return 'Occupied Units Value Less Than 50k';

                case "Owner Occupied Units: Value >$1 Million":
                case "Occupied Units Value O Ver 1 Million":
                    return 'Occupied Units Value Over 1 Million';

                case "Owner-Occupied Units with Mortgage":
                case "Occupied Unitswith Mortgage":
                    return 'Occupied Units with Mortgage';

                case "Owner-Occupied Units without Mortgage":
                case "Occupied Unitswithout Mortgage":
                    return 'Occupied Units without Mortgage';

                case "Owner Occupied Units: Value $50k-$99.9k Percent":
                case "Occupied Units Value 50k99-9k Percent":
                    return 'Occupied Units Value 50k-99.9k Percent';

                case "Owner Occupied Units: Value $100k-$149.9k Percent":
                case "Occupied Units Value 100k-149_9k Percent":
                    return 'Occupied Units Value 100k-149.9k Percent';

                case "Owner Occupied Units: Value $150k-$199.9k Percent":
                case "Occupied Units Value 150k-199_9k Percent":
                    return 'Occupied Units Value 150k-199.9k Percent';

                case "Owner Occupied Units: Value $200k-$299.9k Percent":
                case "Occupied Units Value 200k-299_9k Percent":
                    return 'Occupied Units Value 200k-299.9k Percent';

                case "Owner Occupied Units: Value $300k-$499.9k Percent":
                case "Occupied Units Value 300k-499_9k Percent":
                    return 'Occupied Units Value 300k-499.9k Percent';

                case "Owner Occupied Units: Value $500k-$999.9k Percent":
                case "Occupied Units Value 500k-999_9k Percent":
                    return 'Occupied Units Value 500k-999.9k Percent';

                case "Owner Occupied Units: Value < $50k Percent":
                    return 'Occupied Units Value Less Than 50k Percent';

                case "Owner Occupied Units: Value >$1 Million Percent":
                case "Occupied Units Value O Ver 1 Million Percent":
                    return 'Occupied Units Value Over 1 Million Percent';

                case "Owner-Occupied Units with Mortgage Percent":
                case "Occupied Unitswith Mortgage Percent":
                    return 'Occupied Units with Mortgage Percent';

                case "Owner-Occupied Units without Mortgage Percent":
                case "Occupied Unitswithout Mortgage Percent":
                    return 'Occupied Units without Mortgage Percent';


                case "Housing Built 1940-1949":
                    return 'Built 1940-1949';

                case "Housing Built 1950-1959":
                    return 'Built 1950-1959';

                case "Housing Built 1960-1969":
                    return 'Built 1960-1969';

                case "Housing Built 1970-1979":
                    return 'Built 1970-1979';

                case "Housing Built 1980-1989":
                    return 'Built 1980-1989';

                case "Housing Built 1990-1999":
                    return 'Built 1990-1999';

                case "Housing Built 2000-2009":
                    return 'Built 2000-2009';

                case "Units with 1.1-1.5 Occupants Per Room":
                case "1-1_1_5 Occupants Per Room":
                    return '1.1-1.5 Occupants Per Room';

                case "Units with 1.51-plus Occupants Per Room":
                case "1-51_plus Occupants Per Room":
                    return '15-51 Plus Occupants Per Room';

                case "Units with less than 1 Occupant Per Room":
                    return 'With Less Than 1 Occupant Per Room';

                case "Occupied Units Paying Rent":
                    return 'Units Paying Rent';

                case "Occupied Units Paying <$500 Rent":
                    return 'Units Paying Less Than 500 Rent';

                case "Occupied Units Paying $3000 or More Rent":
                    return 'Units Paying 3000 Plus';

                case "Occupied Units Paying $2500-$3000 Rent":
                    return 'Units Paying 2500-2999';

                case "Occupied Units Paying $2000-$2499 Rent":
                    return 'Units Paying 2000-2499';

                case "Occupied Units Paying $1500-$1999 Rent":
                    return 'Units Paying 1500-1999';

                case "Occupied Units Paying $1000-$1499 Rent":
                    return 'Units Paying 1000-1499';

                case "Occupied Units Paying $500-$999 Rent":
                    return 'Units Paying 500-9999';

                /*case "Occupied Housing Units":
                  return 'Housing Units';
        */
                case "Mobile Home Housing Units":
                    return 'Home Housing Units';

                case "Boat-RV-Van Housing Units":
                    return 'R V Van Housing Units';


                case "Some College/Associate's Degree":
                    return 'College Or Associates Degree';

                case "Bachelor's degree":
                    return 'Degree';

                case "Graduate/Professional degree":
                    return 'Professional Degree';

                case "High School Graduate":
                    return 'School Graduate';

                case "Per Capita Income ($)":
                    return 'Capita Income';

                case "Total Commuters":
                    return 'Commuters';

                case "Total households":
                    return 'Households';

                case "Work at Home":
                    return 'At Home';

                case "Civilian Labor Force":
                    return 'Labor Force';

                case "Civilian employment":
                    return 'Employment';

                case "":
                    return 'Unemployed';

                case "Labor force":
                    return 'Force';

                case "Median Value of Owner Occupied Units":
                    //case "Valueof Owner Occupied Units":
                    return 'Value of Owner Occupied Units';

                case "Valueof Owner Occupied Units Temp":
                    return 'Value of Owner Occupied Units Temp';

                case "Median Age":
                    return 'Age';

                case "Median Rent Paid":
                    return 'Rent Paid';

                /*case "Mean HH Income ($)":
                  return 'H H Income';
        */
                case "Female":
                    return 'Total Female';
                case "Male":
                    return 'Total Male';
                case "Population 25+ Years":
                    return '25 Plus Years';
                case "Population: 16-plus Years":
                    return '16 Plus Years';
                case "Total population":
                    return 'Total';


                case "Percent":
                    return 'Unemployed Percent';

                case "15to29":
                    return 'Commute 15-29 Minutes';

                case "30to44":
                    return 'Commute 30-44 Minutes';

                case "45to89":
                    return 'Commute 45-89 Minutes';

                case "15to29 Percent":
                    return 'Commute 15-29 Minutes Percent';

                case "30to44 Percent":
                    return 'Commute 30-44 Minutes Percent';

                case "45to89 Percent":
                    return 'Commute 45-89 Minutes Percent';

                case "Mean H H Income":
                    return 'Mean HH Income ($)';

                case "Mean H H Income Percent":
                    return 'Mean HH Income ($) Percent';

                case "H H Income":
                    return 'Median HH Income ($)';

                case "H H Income Percent":
                    return 'Median HH Income ($) Percent'

                case "Housing Units":
                    return 'Total Housing Units'

                case "Housing Units Percent":
                    return 'Total Housing Units Percent'

                case "Built 2010or Later":
                    return 'Housing Built 2010 or Later';

                case "Built 2010or Later Percent":
                    return 'Housing Built 2010 or Later Percent';

                case "Built 1939or Before":
                    return 'Housing Built 1939 or Before';

                case "Built 1939or Before Percent":
                    return 'Housing Built 1939 or Before Percent';

                case "Units with 1.1-1.5 Occupants Per Room Percent":
                case "1-1_1_5 Occupants Per Room Percent":
                    return '1.1-1.5 Occupants Per Room Percent';

                case "Units with 1.51-plus Occupants Per Room Percent":
                case "1-51_plus Occupants Per Room Percent":
                    return '15-51 Plus Occupants Per Room Percent';


                case "Valueof Owner Occupied Units":
                    return 'Median Value of Owner Occupied Units ($)';

                default:
                    return title;
            }
        },
        generateReport() {
            this.$refs.html2Pdf.generatePdf()
        },
        onProgress($e) {
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            this.pdfLoading = true;
            this.$store.commit('user/SET_PDF_LOADING', true);

            let page1 = this.$refs.page1;
            let page2 = this.$refs.page2;
            let page3 = this.$refs.page3;
            let page4 = this.$refs.page4;
            let page5 = this.$refs.page5;
            let page6 = this.$refs.page6;
            let page7 = this.$refs.page7;
            let page8 = this.$refs.page8;
            let page9 = this.$refs.page9;
            let page10 = this.$refs.page10;
            let page11 = this.$refs.page11;
            let page12 = this.$refs.page12;
            let page13 = this.$refs.page13;
            let page14 = this.$refs.page14;
            let page15 = this.$refs.page15;
            let page16 = this.$refs.page16;
            let page17 = this.$refs.page17;
            let page18 = this.$refs.page18;
            let page19 = this.$refs.page19;
            let page20 = this.$refs.page20;
            let page21 = this.$refs.page21;
            let page22 = this.$refs.page22;

            let pages = [
                page1,
                page2,
                page3,
                page4,
            ];

            // this.locationsChunks.forEach((chunk, index) => {
            //      if (this.$refs['locationChunk' + index]) {
            //          pages.push(this.$refs['locationChunk' + index][0]);
            //      }
            //  });

            pages.push(page5);
            pages.push(page6);
            pages.push(page7);
            pages.push(page8);
            pages.push(page9);
            pages.push(page10);
            pages.push(page11);
            pages.push(page12);
            pages.push(page13);
            pages.push(page14);
            pages.push(page15);
            pages.push(page16);
            pages.push(page17);

            if (this.demographics && !this.isRingAnalysis) {
                pages.push(page18);
                pages.push(page19);
                pages.push(page20);
                pages.push(page21);
                pages.push(page22);
            }
            if (this.isRingAnalysis)
                this.demographicsChunk.forEach((dem, index) => {
                    if (this.$refs['demographicsChunk' + index]) {
                        pages.push(this.$refs['demographicsChunk' + index][0]);
                    }
                });

            options.pagebreak = { avoid: '.industry-location', mode: 'css', after: '.br-after' };
            var worker = html2pdf().set(options).from(pages[0]).toPdf();
            pages.slice(1).forEach(function (page) {
                worker = worker.get('pdf').then(function (pdf) {
                    pdf.addPage();
                }).from(page).toContainer().toCanvas().toPdf();
            });
            // worker = worker.save();

            worker.get("pdf").then((pdf) => {
                if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
                else window.open(pdf.output("bloburl"), "_blank");
            });
        },
        async afterDownload() {
            this.pdfLoading = false;
            this.$store.commit('user/SET_PDF_LOADING', false);
        },
        init() {

            this.tableData = Object.entries(this.tableCompetitors).map(([table, data]) => ({
                name: table,
                dates: Object.values(data),
            }));

            this.tableData.forEach((element) => {
                let v = Object.values(element.dates);
                let r = [];
                v.forEach((element) => {
                    r.push(element);
                });
                r.unshift(element.name);
                this.filtered_population.push(r);
            });
            this.marketAreaData = {
                labels: this.years,
                data: this.tableData.map((item) => ({
                    name: item.name,
                    data: item.dates,
                })),
                tableData: this.tableData
            }

            // Market
            this.tableDataMarketVolume = Object.entries(this.marketVolume).map(
                ([table, data]) => ({
                    name: table,
                    dates: Object.values(data),
                })
            );
            this.tableDataMarketShare = Object.entries(this.marketShare).map(
                ([table, data]) => ({
                    name: table,
                    dates: Object.values(data),
                })
            );

            // Annual
            this.tableDataMarketAnnualSales = Object.entries(
                this.annualSales
            ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
            let me = this;
            this.tableDataMarketAnnualSales.map((item) => {
                item.dates = item.dates.map((e) => {
                    return me.numberWithCommas(e);
                });
                return item;
            });

            // Covid
            this.tableDataMarketCovidImpact = this.covidColumns.map((name, index) => ({ name, dates: Object.values(this.covid).map(item => item[index]) }));
            this.names = Object.keys(this.covid);
            this.tableDataMarketCovidImpactChange = Object.entries(this.covidChange).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
            this.tableDataMarketCovidImpactChange = this.tableDataMarketCovidImpactChange.map((name, index) => {
                return { dates: name.dates.filter(element => { return element !== ''; }), name: name.name };
            });



            this.covidImpactChangeLineChart = {
                data: {
                    labels: this.covidChangeColumns,
                    series: this.tableDataMarketCovidImpactChange.map(item => ({ name: item.name, data: item.dates.map(i => typeof i === 'string' ? Number(i.replace('%', '')) : i) }))
                }
            };

            // Penetration
            let tableDataMarketPenetration = Object.entries(
                this.penetration
            ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
            // let me2 = this;
            tableDataMarketPenetration = tableDataMarketPenetration.map((item) => {
                item.dates = item.dates.map((e) => {
                    return me.numberWithCommas(e);
                });
                return item;
            });

            this.penetrationData = {
                labels: this.years,
                data: tableDataMarketPenetration.map((item) => ({
                    name: item.name,
                    data: item.dates,
                })),
                tableDataMarketPenetration: tableDataMarketPenetration
            }

            this.tableDataMarketEmployment = Object.entries(this.employment).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

            // Employment

            this.employmentData = {
                labels: this.years,
                data: this.tableDataMarketEmployment.map((item) => ({
                    name: item.name,
                    data: item.dates,
                })),
                tableDataMarketEmployment: this.tableDataMarketEmployment
            }

            let tableDataMarketEmploymentChart = this.tableDataMarketEmployment;
            tableDataMarketEmploymentChart.shift();
            this.employmentChartData = {
                labels: this.years,
                data: tableDataMarketEmploymentChart.map((item) => ({
                    name: item.name,
                    data: item.dates,
                })),
                tableDataMarketEmployment: tableDataMarketEmploymentChart
            }

            // SalesEmpClasses
            if (this.salesEmpSales) {
                this.tableDataMarketEmpVolume = Object.entries(
                    this.salesEmpSales.marketVolume
                ).map(([name, data]) => ({
                    name,
                    dates: data,
                }));
                this.tableDataPercentMarketVolumeClass = Object.entries(
                    this.salesEmpSales.percentMarket
                ).map(([name, data]) => ({
                    name,
                    dates: data,
                }));
                this.tableDataAverageSalesClass = Object.entries(
                    this.salesEmpSales.avgSales
                ).map(([name, data]) => ({
                    name,
                    dates: data,
                }));
            };

            if (this.salesEmpEmployment) {
                this.tableDataEstablishments = Object.entries(
                    this.salesEmpEmployment.establishments
                ).map(([name, data]) => ({
                    name,
                    dates: data,
                }));

                this.tableDataTotalEmployment = Object.entries(
                    this.salesEmpEmployment.total
                ).map(([name, data]) => ({
                    name,
                    dates: data,
                }));

                this.tableDataAverageEmployment = Object.entries(
                    this.salesEmpEmployment.average
                ).map(([name, data]) => ({
                    name,
                    dates: data,
                }));
            }

            // Productivity
            if (this.productivityValues) {
                this.tableDataSalesPerEmployee = Object.entries(this.productivityValues.spe).map(([name, data]) => ({ name, dates: data }));

                this.tableDataSalesPerEmployee.map(item => {
                    item.dates = item.dates.map(e => {
                        return me.numberWithCommas(e)
                    })
                    return item
                })
                this.tableDataAverageAnnualWage = Object.entries(this.productivityValues.annualWage).map(([name, data]) => ({ name, dates: data }));
                this.tableDataAverageAnnualWage.map(item => {
                    item.dates = item.dates.map(e => {
                        return me.numberWithCommas(e)
                    })
                    return item
                })
                this.tableDataRentPerEmployee = Object.entries(this.productivityValues.rent).map(([name, data]) => ({ name, dates: data }));
                this.tableDataRentPerEmployee.map(item => {
                    item.dates = item.dates.map(e => {
                        return me.numberWithCommas(e)
                    })
                    return item
                })

                let competitorsCounts = [0, 0, 0, 0];
                this.tableData.forEach((item) => {
                    item.dates.forEach((date, index) => {
                        competitorsCounts[index] = competitorsCounts[index] + date;
                    });
                });

                this.tableDataSalesPerEmployeeChart = {
                    labels: this.years,
                    data: this.tableDataSalesPerEmployee.map((item) => ({
                        name: item.name,
                        data: item.dates.map((date, index) => {
                            return (Math.round(parseInt(date.replaceAll(',', '')) / competitorsCounts[index]));
                        }),
                    })),
                    tableDataSalesPerEmployee: this.tableDataSalesPerEmployee
                }
            }

            // Startups

            if (this.startupsValues) {
                this.tableDataStartupPerformance = Object.entries(this.startupsValues).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
                this.tableDataStartupActivityRates = Object.entries(this.startupsIndex).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

                this.tableDataStartupActivityRates.map(item => {
                    item.dates = item.dates.map(e => {
                        return me.numberWithCommas(e)
                    })
                    return item
                })

                this.tableDataStartupActivityRates = this.tableDataStartupActivityRates.concat(this.tableDataStartupPerformance);

                this.tableDataStartupPerformanceChart = {
                    labels: this.years,
                    data: [{
                        name: this.tableDataStartupPerformance[0].name,
                        data: this.tableDataStartupPerformance[0].dates,
                    }],
                    tableDataStartupPerformance: this.tableDataStartupPerformance
                }

                this.startupActivityRatesLineChart.data = {
                    labels: this.years,
                    series: this.tableDataStartupActivityRates.map(item => ({ name: item.name, data: item.dates }))
                };
            }

            // Cessation
            if (this.cessation) {
                this.tableDataCessationRates = Object.entries(
                    this.cessation
                ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
                this.tableDataCessationRates.map((item) => {
                    item.dates = item.dates.map((e) => {
                        return me.numberWithCommas(e);
                    });
                    return item;
                });
            }

            if (this.chartData && this.chartData.data) {

                this.tableDataCessationChart = {
                    labels: this.years,
                    data: this.tableDataCessationRates.map((item) => ({
                        name: item.name,
                        data: item.dates,
                    })),
                    tableDataCessationRates: this.tableDataCessationRates
                }


                let populationData = Object.entries(this.tableCompetitors).map(
                    ([table, data]) => ({
                        name: table,
                        dates: Object.values(data),
                    })
                );
                populationData.forEach((element) => {
                    let v = Object.values(element.dates);
                    let r = [];
                    v.forEach((element) => {
                        r.push(element);
                    });
                    r.unshift(element.name);
                    this.filtered_population.push(r);
                });
            }

            if (this.ownership) {
                this.tableDataBranchConcentration = Object.entries(this.ownership).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

                this.tableDataBranchConcentrationChart = {
                    labels: this.years,
                    data: this.tableDataBranchConcentration.map((item) => ({
                        name: item.name,
                        data: item.dates,
                    })),
                    tableDataBranchConcentration: this.tableDataBranchConcentration
                }
            }

            let penetrationData = Object.entries(this.penetration).map(
                ([table, data]) => ({
                    name: table,
                    dates: Object.values(data),
                })
            );
            penetrationData.map((item) => {
                item.dates = item.dates.map((e) => {
                    return me.numberWithPoints(e);
                });
                return item;
            });
            penetrationData.forEach((element) => {
                let v = Object.values(element.dates);
                let r = [];
                v.forEach((element) => {
                    r.push(element);
                });
                r.unshift(element.name);
                this.filtered_penetration.push(r);
            });

            if (this.tableDemog3Ring && this.isRingAnalysis) {
                var values = Object.values(this.demographics);
                var final = [];
                var counter = 0;
                var portion = {};

                for (var key in this.demographics) {
                    if (counter !== 0) {
                        final.push(portion);
                        portion = {};
                    }
                    portion[key] = values[counter];
                    counter++
                }
                final.push(portion);
                this.demographicsChunk = final;

            }

        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            } else {
                return x;
            }
        },
        numberWithPoints(x) {
            if (typeof x === 'number') {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            } else if (typeof x === 'string') {
                return x.replace(/,/g, '.');
            } else {
                return x;
            }
        },
    },
}
</script>